<template>
    <div id="app">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item><a href="/">做家教管理</a></el-breadcrumb-item>
            <el-breadcrumb-item>做家教列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 卡片视图区域 -->
        <el-card>
            <el-table :data="YoujiList" border stripe>
                <el-table-column type="index" label="#"></el-table-column>
                <el-table-column prop="bianhao" label="编号"></el-table-column>
                <el-table-column prop="username" label="姓名"></el-table-column>
				<el-table-column prop="nianji" label="年级"></el-table-column>
				<el-table-column prop="kemu" label="科目"></el-table-column>
				<el-table-column prop="tel" label="电话"></el-table-column>
                <el-table-column label="操作" width="180px">
                    <template slot-scope="scope">
                        <el-button type="danger" icon="el-icon-delete" size="mini"
							@click="del(scope.row.id)"></el-button>
                    </template>
                </el-table-column>
				
            </el-table>

            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pageNum" :page-sizes="[2, 4, 6, 8]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </el-card>

    </div>
</template>

<script>
import { getUserList, addUserList, selectUserList, editUserList,delUserList,Youjiadd,YoujiList,Youjidel} from '@/api/index.js'
export default {
    data() {
        return {
            YoujiList: [],
			pageNum:1,
			pageSize:10,
            total: 0,
        }
    },
    created() {
        this.getYoujiList();
    },
    methods: {
        async getYoujiList() {
            const { data: res } = await YoujiList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            });
            this.YoujiList = res.data.list;
            this.total = res.data.total;
        },
        handleSizeChange(newsize) {
            this.pageSize = newsize;
            this.getYoujiList();
        },
        handleCurrentChange(newnum) {
            this.pageNum = newnum;
            this.getYoujiList();
        },
		async del(id){
			const { data: res } = await Youjidel({id});
			if(res.code==200){
				this.$message.success('删除成功');
				this.getYoujiList();
			}else{
				this.$message.success('删除失败');
			}
		},
		successimg(response){
			console.log(response);
			this.addForm.img = response.pic;
		}
    }
}
</script>
<style scoped>
.el-card {
    margin-top: 20px;
}

.el-row {
    margin-bottom: 20px;
}
</style>